import { Column, Row, SmallMessage } from "components/styles";
import {
	Container,
	DividerTitle,
	Title,
	Description,
} from "views/components/AttendanceList/TakeTeacherAttendancePanel/styles";
import pinIcon from "img/pin_icon.svg";
import CustomButton from "components/CustomButton/CustomButton";
import { CUSTOM_BUTTON_PROPS } from "views/components/AttendanceList/TakeTeacherAttendancePanel/constants";

const TeacherAttendancePlaceholder = ({
	teacherName,
	askTeacherTakeAttendance,
	dataTeacherAttendance,
	disableForCheckTimeButton,
}) => {
	const { checkInTime } = dataTeacherAttendance;
	return (
		<Container
			direction="row"
			align="center"
		>
			<Column
				gap="8px"
				width="max-content"
				grow="1"
			>
				{/* NOTA: Considerar esta validación si llegasen a requerir la marcación de salida. */}
				{/* {!checkInTime && !checkOutTime ? ( */}
				{!checkInTime ? (
					<Title weight="bold">{teacherName}</Title>
				) : (
					<CheckTimeReadyPart {...dataTeacherAttendance} />
				)}
				<CheckTimeMessage {...dataTeacherAttendance} />
			</Column>
			<Column
				minWidth="unset"
				width="max-width"
				align="center"
				gap="5px"
			>
				{!checkInTime && (
					<CustomButton
						{...CUSTOM_BUTTON_PROPS}
						text="Marcar entrada"
						onClick={askTeacherTakeAttendance.askCheckInAttendance}
						disabled={disableForCheckTimeButton.disabled}
					/>
				)}
				{/* NOTA: Considerar este fragmento si llegasen a requerir la marcación de salida. */}
				{/* {checkInTime && (
					<CustomButton
						{...CUSTOM_BUTTON_PROPS}
						text="Marcar salida"
						onClick={askTeacherTakeAttendance.askCheckOutAttendance}
						disabled={
							(checkInTime && checkOutTime) ||
							disableForCheckTimeButton.disabled
						}
					/>
				)} */}
				{disableForCheckTimeButton.isFinalizedCheckTime && (
					<SmallMessage>Evento finalizado</SmallMessage>
				)}
			</Column>
		</Container>
	);
};

function CheckTimeReadyPart({ checkInTime, checkOutTime }) {
	return (
		<Row gap="15px">
			<Title>
				Hora de entrada: <strong>{checkInTime}</strong>
			</Title>
			<DividerTitle>|</DividerTitle>
			<Title>
				Hora de salida: <strong>{checkOutTime || "-"}</strong>
			</Title>
		</Row>
	);
}
function CheckTimeMessage({ checkInTime, checkOutTime }) {
	return (
		<Row>
			<img
				src={pinIcon}
				alt="Ícono de fijamiento"
			/>
			<Description>
				{!checkInTime && !checkOutTime
					? // ? "No olvides que debes marcar tu entrada y tu salida al finalizar la clase."
					  "No olvides que debes marcar tu entrada al empezar la clase."
					: "Toma la asistencia de los estudiantes para poder marcar tu salida."}
			</Description>
		</Row>
	);
}

export default TeacherAttendancePlaceholder;
